export const MODIFY_EDIT_QUERY_INFO = 'MODIFY_EDIT_QUERY_INFO';

export function modifyEditQueryInfo(editQueryInfo){
    return{
        type: MODIFY_EDIT_QUERY_INFO,
        mainState: {
            editQueryInfo: editQueryInfo
        }
    }
}